/* unplugin-vue-components disabled */import script from "./Key.vue?vue&type=script&setup=true&lang=ts"
export * from "./Key.vue?vue&type=script&setup=true&lang=ts"

import "./Key.vue?vue&type=style&index=0&id=58018160&scoped=true&lang=less"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58018160"]])

export default __exports__